// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Lamentations",
  bookSlug: "lamentations",
  chapter: 3,
  argument: "",
  verses: [
    { n: 1, text: "Aleph. I am the man that see my poverty by the rod of his indignation." },
    { n: 2, text: "Aleph. He hath led me, and brought me into darkness, and not into light." },
    { n: 3, text: "Aleph. Only against me he hath turned, and turned again his hand all the day." },
    { n: 4, text: "Beth. My skin and my flesh he hath made old, he hath broken my bones." },
    { n: 5, text: "Beth. He hath built round about me, and he hath compassed me with gall, and labour." },
    { n: 6, text: "Beth. He hath set me in dark places, as those that are dead for ever." },
    { n: 7, text: "Ghimel. He hath built against me round about, that I may not get out: he hath made my fetters heavy." },
    { n: 8, text: "Ghimel. Yea, and when I cry, and entreat, he hath shut out my prayer." },
    { n: 9, text: "Ghimel. He hath shut up my ways with square stones, he hath turned my paths upside down." },
    { n: 10, text: "Daleth. He is become to me as a bear lying in wait: as a lion in secret places." },
    { n: 11, text: "Daleth. He hath turned aside my paths, and hath broken me in pieces, he hath made me desolate." },
    { n: 12, text: "Daleth. He hath bent his bow, and set me as a mark for his arrows." },
    { n: 13, text: "He. He hath shot into my reins the daughters of his quiver." },
    { n: 14, text: "He. I am made a derision to all my people, their song all the day long." },
    { n: 15, text: "He. He hath filled me with bitterness, he hath inebriated me with wormwood." },
    { n: 16, text: "Vau. And he hath broken my teeth one by one, he hath fed me with ashes." },
    { n: 17, text: "Vau. And my soul is removed far off from peace, I have forgotten good things." },
    { n: 18, text: "Vau. And I said: My end, and my hope is perished from the Lord." },
    { n: 19, text: "Zain. Remember my poverty, and transgression, the wormwood and the gall." },
    { n: 20, text: "Zain. I will be mindful, and remember, and my soul shall languish within me." },
    { n: 21, text: "Zain. These things I shall think over in my heart, therefore will I hope." },
    { n: 22, text: "Heth. The mercies of the Lord that we are not consumed: because his commiserations have not failed." },
    { n: 23, text: "Heth. They are new every morning, great is thy faithfulness." },
    { n: 24, text: "Heth. The Lord is my portion, said my soul: therefore will I wait for him." },
    { n: 25, text: "Teth. The Lord is good to them that hope in him, to the soul that seeketh him." },
    { n: 26, text: "Teth. It is good to wait with silence for the salvation of God." },
    { n: 27, text: "Teth. It is good for a man, when he hath borne the yoke from his youth." },
    { n: 28, text: "Jod. He shall sit solitary, and hold his peace: because he hath taken it up upon himself." },
    { n: 29, text: "Jod. He shall put his mouth in the dust, if so be there may be hope." },
    { n: 30, text: "Jod. He shall give his cheek to him that striketh him, he shall be filled with reproaches." },
    { n: 31, text: "Caph. For the Lord will not cast off for ever." },
    { n: 32, text: "Caph. For if he hath cast off, he will also have mercy, according to the multitude of his mercies." },
    { n: 33, text: "Caph. For he hath not willingly afflicted, nor cast off the children of men." },
    { n: 34, text: "Lamed. To crush under his feet all the prisoners of the land," },
    { n: 35, text: "Lamed. To turn aside the judgment of a man before the face of the most High," },
    { n: 36, text: "Lamed. To destroy a man wrongfully in his judgment, the Lord hath not approved." },
    { n: 37, text: "Mem. Who is he that hath commanded a thing to be done, when the Lord commandeth it not?" },
    { n: 38, text: "Mem. Shall not both evil and good proceed out of the mouth of the Highest?" },
    { n: 39, text: "Mem. Why hath a living man murmured, man suffering for his sins?" },
    { n: 40, text: "Nun. Let us search our ways, and seek, and return to the Lord." },
    { n: 41, text: "Nun. Let us lift up our hearts with our hands to the Lord in the heavens." },
    { n: 42, text: "Nun. We have done wickedly, and provoked thee to wrath: therefore thou art inexorable." },
    { n: 43, text: "Samech. Thou hast covered in thy wrath, and hast struck us: thou hast killed, and hast not spared." },
    { n: 44, text: "Samech. Thou hast set a cloud before thee, that our prayer may not pass through." },
    { n: 45, text: "Samech. Thou hast made me as an outcast, and refuse, in the midst of the people." },
    { n: 46, text: "Phe. All our enemies have opened their mouths against us." },
    { n: 47, text: "Phe. Prophecy is become to us a fear, and a snare, and destruction." },
    { n: 48, text: "Phe. My eye hath run down with streams of water, for the destruction of the daughter of my people." },
    { n: 49, text: "Ain. My eye is afflicted, and hath not been quiet, because there was no rest:" },
    { n: 50, text: "Ain. Till the Lord regarded, and looked down from the heavens." },
    { n: 51, text: "Ain. My eye hath wasted my soul, because of all the daughters of my city." },
    { n: 52, text: "Sade. My enemies have chased me, and caught me like a bird, without cause." },
    { n: 53, text: "Sade. My life is fallen into the pit, and they have laid a stone over me." },
    { n: 54, text: "Sade. Waters have flowed over my head: I said: I am cut off." },
    { n: 55, text: "Coph. I have called upon thy name, O Lord, from the lowest pit." },
    { n: 56, text: "Coph. Thou hast heard my voice: turn not away thy ear from my sighs, and cries." },
    { n: 57, text: "Coph. Thou drewest near in the day, when I called upon thee: thou saidst: Fear not." },
    { n: 58, text: "Res. Thou hast judged, O Lord, the cause of my soul, thou the Redeemer of my life." },
    { n: 59, text: "Res. Thou hast seen, O Lord, their iniquity against me, judge thou my judgment." },
    { n: 60, text: "Res. Thou hast seen all their fury, and all their thoughts against me." },
    { n: 61, text: "Sin. Thou hast heard their reproach, O Lord, all their imaginations against me." },
    { n: 62, text: "Sin. The lips of them that rise up against me: and their devices against me all the day." },
    { n: 63, text: "Sin. Behold, their sitting down, and their rising up, I am their song." },
    { n: 64, text: "Thau. Thou shalt render them a recompense, O Lord, according to the works of their hands." },
    { n: 65, text: "Thau. Thou shalt give them a buckler of heart, thy labour." },
    { n: 66, text: "Thau. Thou shalt persecute them in anger, and shalt destroy them from under the heavens, O Lord." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Man. Jeremias had a share in the common misery, (Worthington) and bewails his own condition, as a figure of Christ, Psalm lxxxvii. 16., and Isaias liii. 3. (Calmet) — His disciples must expect to suffer.", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "Led, or driven me with the rod. (Haydock) — God employs two, Zacharias xi. 7. That of rigour was reserved for this prophet; (chap. xxxviii.) none of them suffered more.", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "Old and wrinkled, the effect of misery.", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: "Gall. Septuagint, \"head.\" Chaldean, \"he hath seized the chief,\" Job xvi. 13. He speaks in the name of the besieged, who had been threatened with this punishment,", attribution: "Haydock" }
    ] },
    { verse: 19, notes: [
      { text: ", and chap. viii. 14. (Calmet) — And labour. Nabuzardan ransacked the city worse than his master, (Worthington) if the latter was at all present.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Ever indeed, Ecclesiastes xii. 5., and Psalm xlviii. 12. Jeremias (xxxviii. 6.) was in imminent danger.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Prayer. God would not allow him to pray for the people, chap. vii. 16.", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "Stones. There is no passage, Job xix. 8.", attribution: "Haydock" }
    ] },
    { verse: 10, notes: [
      { text: "Places. This may refer to the prophet or to the people.", attribution: "Haydock" }
    ] },
    { verse: 12, notes: [
      { text: "Arrows. Such places were common where shooting was practised, 1 Kings xx. 36., and Job xvi. 11.", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "Song. True prophets were derided on account of impostors, and because their declarations were unpleasant, &c., chap. xvii. 15., and Ezechiel xii. 22.", attribution: "Haydock" }
    ] },
    { verse: 15, notes: [
      { text: "Wormwood, or a bitter poisonous herb, chap. ix. 26., and Deuteronomy xxix. 18.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "One. Hebrew, \"against a stone.\" My bread is full of them, Psalm ci. 10. (Calmet) — He describes his afflictions, as if his teeth had been broken.", attribution: "Worthington" }
    ] },
    { verse: 18, notes: [
      { text: "End. Hebrew, \"strength.\" Septuagint, \"victory.\"", attribution: "Calmet" }
    ] },
    { verse: 21, notes: [
      { text: "Hope. The remembrance fills him with grief and hope, chap. xx. 12.", attribution: "Haydock" }
    ] },
    { verse: 23, notes: [
      { text: "New. Novi should be nov�, to agree with miserationes. (Calmet) — Chaldean, \"new miracles\" occur daily. (Haydock) — God's mercies are ever fresh.", attribution: "Worthington" }
    ] },
    { verse: 27, notes: [
      { text: "Yoke. Afflictions endured for justice sake ensure a blessing. (Haydock) — All may derive great benefit from suffering.", attribution: "Haydock" }
    ] },
    { verse: 28, notes: [
      { text: "Himself, with perfect resignation.", attribution: "Haydock" }
    ] },
    { verse: 29, notes: [
      { text: "Hope. He does not doubt, but confides with great humility.", attribution: "Haydock" }
    ] },
    { verse: 30, notes: [
      { text: "Him. We cannot verify this of the prophet as we can of Christ, (Matthew xxvi. 62.; Calmet) to whom this particularly refers.", attribution: "Worthington" }
    ] },
    { verse: 33, notes: [
      { text: "Men. He punishes with regret, Ezechiel xviii. 23. Our crimes force him to chastise,", attribution: "Haydock" }
    ] },
    { verse: 36, notes: [
      { text: "(Calmet) — Yet he seeks our advantage.", attribution: "Worthington" }
    ] },
    { verse: 37, notes: [
      { text: "Commanded. Hebrew, \"said: It cometh to pass,\" as if by chance. There have always been Epicureans, Ezechiel viii. 12., and Psalm xciii. 7. (Calmet) — Those who deny Providence speak,", attribution: "Haydock" }
    ] },
    { verse: 39, notes: [
      { text: "Sins? If all happened by inevitable necessity, or according to the laws of Providence, why should any one complain?", attribution: "Haydock" }
    ] },
    { verse: 41, notes: [
      { text: "Up. This posture \"is the testimony of a soul naturally Christian.\" (Tertullian, Apol.) — Our heart must accompany our hands, 1 Timothy ii. 8.", attribution: "Calmet" }
    ] },
    { verse: 42, notes: [
      { text: "Inexorable. Hebrew and Septuagint, \"Thou hast not shewn pity.\"", attribution: "Haydock" }
    ] },
    { verse: 43, notes: [
      { text: "Covered thyself, as if not to see our distress.", attribution: "Haydock" }
    ] },
    { verse: 44, notes: [
      { text: "Cloud. Isaias lix. 2., and Ecclesiasticus xxxv. 21. These expressions are admirable.", attribution: "Haydock" }
    ] },
    { verse: 47, notes: [
      { text: "Prophecy. Many would read, vastatio. Hebrew, \"ruin.\" Septuagint, \"taking away.\" (Calmet) — Protestants, \"Fear and a snare is come upon us, desolation and destruction.\" The prophets were continually in danger. (Haydock) — The preaching of false prophets has brought these evils upon the people.", attribution: "Worthington" }
    ] },
    { verse: 51, notes: [
      { text: "Wasted. Literally, \"robbed.\" (Haydock) — I have felt more for my people than they have themselves. Moral writers often produce this text, to shew the dangers of an unguarded glance (Calmet) at women.", attribution: "Haydock" }
    ] },
    { verse: 53, notes: [
      { text: "Over me, as if I were buried. (Haydock) — Jeremias was in prison (chap. xxxviii. 6.) when he prayed,", attribution: "Haydock" }
    ] },
    { verse: 54, notes: [
      { text: ", and chap. xx. 7.", attribution: "Calmet" }
    ] },
    { verse: 59, notes: [
      { text: "Judge what they have judged unjustly.", attribution: "Worthington" }
    ] },
    { verse: 62, notes: [
      { text: "Lips; or language (Genesis xi. 1.) thou knowest,", attribution: "Haydock" }
    ] },
    { verse: 63, notes: [
      { text: "Up, all their conduct. — Song.", attribution: "Haydock" }
    ] },
    { verse: 65, notes: [
      { text: "Buckler, to cover all the body. They shall be surrounded with misery, (Psalm cviii. 29.) while God will protect his servants, Psalm v. 13. (Calmet) — Let sorrow pierce their heart, as thy enemies are treated.", attribution: "Worthington" }
    ] },
  ],
};

export default chapter;
